import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Banner() {
  const [isVisible, setIsVisible] = useState(false);
  const bannerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Check if banner was previously dismissed
    const dismissed = localStorage.getItem('banner-dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);
  useEffect(() => {
    const updateHeight = () => {
      const height = bannerRef.current?.offsetHeight || 0;
      document.documentElement.style.setProperty('--banner-height', `${height}px`);
    };
    // Initial update
    updateHeight();
    // Create ResizeObserver to handle animations and window resizing
    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });
    if (bannerRef.current) {
      resizeObserver.observe(bannerRef.current);
    }
    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.removeProperty('--banner-height');
    };
  }, [isVisible]);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('banner-dismissed', 'true');
    // Reset height immediately on dismiss start, or let observer handle it?
    // Observer might be slightly delayed during animation, but usually fine.
    // For smoother exit, we might want to animate the variable too, but ResizeObserver is best for accuracy.
  };
  return <AnimatePresence mode="wait" data-id="element-44">
      {isVisible && <motion.div ref={bannerRef} initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="fixed top-0 left-0 right-0 z-50 overflow-hidden" onAnimationComplete={() => {
      // Ensure final height is set correctly after animation
      const height = bannerRef.current?.offsetHeight || 0;
      document.documentElement.style.setProperty('--banner-height', `${height}px`);
    }} data-id="element-45">
          <div className="bg-gradient-to-r from-neon-purple to-neon-pink text-white px-4 py-3" data-id="element-46">
            <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm font-medium pr-8" data-id="element-47">
              <span className="text-center" data-id="element-48">
                🚀 Now Accepting New Projects for 2024 - Limited Spots Available
              </span>
              <a href="#contact" className="underline decoration-white/50 hover:decoration-white transition-colors whitespace-nowrap" data-id="element-49">
                Get Started →
              </a>
            </div>

            <button onClick={handleDismiss} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Dismiss banner" data-id="element-50">
              <X size={16} data-id="element-51" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}